import {
    GET_ALL_USER_BOOKMARKS,
    IS_LOADING,
  } from './userBookmarksActionsTypes';
  
  const INITIAL_STATE = {
    userAllBookmarks: [],
    isLoading: false,
  };
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case GET_ALL_USER_BOOKMARKS:
        return {
          ...state,
          userAllBookmarks: action.payload,
        };
        case IS_LOADING:
          return {
            ...state,
            isLoading: action.payload,
          };
      default:
        return state;
    }
  };
  